import React, { useState, useEffect } from 'react';
import { Box, TextField, makeStyles } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import Autocomplete from '@material-ui/lab/Autocomplete';
import colors from '../CustomizedUIs/Colors'
import Loading from '../common/loading-page';

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        }, fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingLeft: '16px',
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none"
        },
        "& input": {
            "-moz-appearance": "textfield"
        }
    },
    boxBorder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    multiline: {
        paddingLeft: 27
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    titleCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        paddingLeft: '16px'
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
        paddingLeft: '16px'
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',

    },
    optionText: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    paper: {
        borderRadius: '2px',
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    endAdornment: {
        display: 'none'
    },
}));

function SlideShow() {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const dataProvider = useDataProvider();
    const classes = useStyles();

    const [openPoper, setOpenPopper] = useState(false);
    const [loading, setLoading] = useState(false);
    const [listInfoChannel, setListInfoChannel] = useState([]);
    const [textValue, setTextValue] = useState();
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { infoChannelId } = nodeSelected.applicationData.nodeApplication.slideShow;

    const textOnChange = (event, values) => {
        setTextValue(values)
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                slideShow: {
                    infoChannelId: values ? parseInt(values.split('-')[0]) : null
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const getInfoChannel = () => {
        setLoading(true)
        dataProvider('GET_LIST', 'infochannels', {
            filter: {},
            pagination: {},
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            if (data.length > 0) {
                data.map(item => {
                    item.title = `${item.id} - ${item.name}`
                })
                for (let i = 0; i < data.length; i++) {
                    if (infoChannelId && data[i].id === infoChannelId) {
                        setTextValue(data[i].title)
                        break
                    }
                    else
                        setTextValue(null)
                }
            }
            setListInfoChannel(data)
            setLoading(false)
        }).catch(error => {
            setLoading(true)
            console.log('@@@ getData ERROR', error)
        });
    }

    useEffect(() => {
        getInfoChannel();
    }, []);

    useEffect(() => {
        if (listInfoChannel.length > 0) {
            for (let i = 0; i < listInfoChannel.length; i++) {
                if (infoChannelId && listInfoChannel[i].id === infoChannelId) {
                    setTextValue(listInfoChannel[i].title)
                    break
                }
                else
                    setTextValue(null)
            }
        }
    }, [nodeSelected]);

    if (loading) return <Loading />
    return (
        <Box borderRadius='2px'>
            <Box mt={3.5}>
                <Autocomplete
                    classes={{
                        option: classes.optionText,
                        paper: classes.paper,
                        endAdornment: classes.endAdornment,
                        noOptions: classes.optionText
                    }}
                    style={{ maxWidth: 500 }}
                    disabled={!isEditing}
                    id="auto-complete-slideshow"
                    options={listInfoChannel.map((option) => option.title)}
                    onChange={textOnChange}
                    value={textValue}
                    defaultValue={null}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translate('resources.infoPage.slideShow.infoChannelId')}
                            margin="normal"
                            variant="filled"
                            InputLabelProps={{
                                classes: {
                                    root: classes.textLabel,
                                    error: classes.textLableError
                                }
                            }}
                            InputProps={{
                                ...params.InputProps,
                                className: `${classes.input}`,
                                classes: {
                                    underline: classes.underline,
                                    focused: classes.focuses
                                }
                            }}
                        />
                    )}
                />
            </Box>
        </Box>
    )
}

export default SlideShow;
